import { Injectable } from '@angular/core';
import { NotificationService as CommonNotificationService } from '@caslink/common-client/ng-app/notification/NotificationService';
import { CommonEvents } from '../../enums/common-events.enum';
import { BroadcastService } from '../broadcast/broadcast.service';
import { LogService } from '../log/log.service';
import { IEventBusScope } from '../../interfaces/ievent-bus-scope';
import { ConnectionService } from '../connection/connection.service';
import { AlertCategories } from '@caslink/common-client/ng-app/alerts/typings/AlertCategories';
import { SensorUpdateInfo } from '@caslink/common-client/ng-app/alerts/typings/models';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    constructor(private broadcastService: BroadcastService,
                private logger: LogService,
                private connectionService: ConnectionService,
                private notificationService: CommonNotificationService
    ) {
        this.init();
    }

    public init() {
        this.notificationService.subscriptionKeys.set(16, 'DashboardUpdate');

        (this.notificationService.subscriptionHandlers as any).DashboardUpdate = {
            handler: this.dashboardUpdate.bind(this)
        };

        this.notificationService.subscriptionHandlers.Sensor = {
            category: AlertCategories.Monitoring as any,
            handler: this.sensorUpdate.bind(this)
        };

        this.createProxyRootScope();
    }

    public connect() {
        this.notificationService.connect();
    }

    public disconnect() {
        this.notificationService.disconnect();
    }

    public startUpdates(
        locationId: number,
        subscriptionType: string | number,
        updateCriteria: any,
        subscriptionState: any): Promise<void> {

        if (!this.connectionService.isCASLinkConnectionAlive) {
            return new Promise<void>(resolve => resolve());
        }

        return this.notificationService
            .startUpdates(locationId, subscriptionType as any, updateCriteria, subscriptionState) as Promise<void>;
    }

    public stopUpdates(
        locationId: number,
        subscriptionType: any,
        updateCriteria: any) {

        if (!this.connectionService.isCASLinkConnectionAlive) {
            return new Promise<void>(resolve => resolve());
        }

        return this.notificationService.stopUpdates(locationId, subscriptionType, updateCriteria);
    }

    private dashboardUpdate(locationId: number, data) {
        this.logger.info(`Received Notification: DashboardUpdate`, locationId, data);
        this.broadcastService.broadcast(CommonEvents.DashboardUpdate, data);
    }

    private sensorUpdate(locationId: number, dataPoints: number[][], sensorInfo: any) {
        const sensorId = sensorInfo.sensorId;
        const updatedSensorData = {dataPoints, locationId, sensorId} as SensorUpdateInfo;

        this.broadcastService.broadcast(CommonEvents.SensorUpdate, updatedSensorData);
    }

    private createProxyRootScope() {
        const rootScope = this.notificationService.$rootScope as any as IEventBusScope;
        const subscribe = (eventKey: string | number, listener: (data?: any) => void): any => {
            rootScope.subscribe(eventKey, listener);
        };

        (this.notificationService.$rootScope as any) = {
            $apply: () => rootScope.$apply(),
            $on: (name: string, listener: () => void) => {
                rootScope.$on(name, listener);
            },
            publish: (name, data) => {
                this.logger.log('publishing:', name, data);
                this.broadcastService.broadcast(name, data);
                if (rootScope && rootScope.publish) {
                    rootScope.publish(name, data);
                }
            },
            subscribe
        } as IEventBusScope;

    }
}
